import { appendSearchParams } from '@alexis/helpers/searchParam';
import axios from 'axios';
import type { CancelToken } from 'axios';

import { getForterToken } from '@helpers/forter';

import type { PaymentToken } from '@wegoTypes/flightBooking';
import type { PaymentType } from '@wegoTypes/payments';

export async function getPaymentToken(
  apiBaseUrl: string,
  clientCode: 'bow_fli' | 'bow_hot',
  paymentType: PaymentType,
  encryptedPayload: string,
): Promise<PaymentToken> {
  const url = `${apiBaseUrl}/payments/v1/public/pm/tokens`;

  const response = await axios.post<PaymentToken>(
    url,
    {
      clientCode,
      type: paymentType,
      encryptedData: encryptedPayload,
      forterTokenCookie: getForterToken(),
    },
    { withCredentials: true },
  );

  if (response.status === 200) {
    return response.data;
  }
  throw new Error(response.statusText);
}

// TODO*: Remove after done AB test of migrate payment web component
export async function getPublicPaymentOptions(
  apiBaseUrl: string,
  clientCode: 'bow_fli' | 'bow_hot',
  currencyCode: string,
  currentSiteCode: string,
): Promise<Array<PublicPaymentOption>> {
  const searchParams: any = {
    clientCode,
    userCurrency: currencyCode,
    siteCode: currentSiteCode,
    appType: 'WEB_APP',
  };

  const url = appendSearchParams(
    `${apiBaseUrl}/payments/v1/public/pm/payment-options`,
    searchParams,
  );

  const response = await axios.get<Array<PublicPaymentOption>>(url, {
    withCredentials: true,
  });

  if (response.status === 200) {
    return response.data;
  }
  throw new Error(response.statusText);
}

// TODO*: Remove after done AB test of migrate payment web component
export async function getEvaluated(
  apiBaseUrl: string,
  paymentsEvalulateRequest: PaymentsEvalulateRequest,
  cancelToken?: CancelToken,
): Promise<PaymentsEvalulateResponse> {
  const url = `${apiBaseUrl}/payments/v1/public/pm/evaluate`;

  const response = await axios.post<PaymentsEvalulateResponse>(url, paymentsEvalulateRequest, {
    cancelToken,
    withCredentials: true,
  });

  if (response.status === 200) {
    return response.data;
  }
  throw new Error(response.statusText);
}
